import { css, styled } from 'canoe';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ComponentsSearchFilter } from '@candu-ai/craft/ui';
import { setComponentsSearch, useComponentsSearch } from 'craft/state';

const SearchAndTabsContainer = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spaces.xs};
    position: relative;
    background-color: ${theme.colors.GlitterGray};
    z-index: 80;
  `}
`;

export const ComponentsSearch = () => {
  const search = useComponentsSearch();
  const dispatch = useDispatch();

  const onSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value ?? '';
      dispatch(setComponentsSearch(value.length < 1 ? undefined : value));
    },
    [dispatch, setComponentsSearch],
  );

  return (
    <SearchAndTabsContainer>
      <ComponentsSearchFilter
        onChange={onSearchChange}
        onClear={() => dispatch(setComponentsSearch(undefined))}
        filter={search}
      />
    </SearchAndTabsContainer>
  );
};
